<!-- <div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">

  <ul class="nav navbar-nav flex-row">
    <li class="nav-item">
      <a class="navbar-brand m-0" [routerLink]="['/']">
        <span class="brand-logo">
          <img [src]="
              coreConfig.layout.skin === 'dark'
                ? 'assets/images/logo/osquare.dark.png'
                : coreConfig.app.appLogoImage
            " alt="brand-logo" style="max-width: none; height: 60px" />
        </span>
        <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2>
      </a>
    </li>
  </ul>
</div> -->

<div class="navbar-container d-flex justify-content-between" id="app-navbar"
  [class.setup-rtl]="currentLanguage === 'ar'">
  <ul class="nav navbar-nav align-items-center d-none d-md-flex" style="z-index: 10">
    <li ngbDropdown class="nav-item dropdown-notification mr-25" #dropdown="ngbDropdown" *ngIf="!isCustomerPortalUser">
      <app-nine-icons *renderIf="{ roles: ['employee', 'customer'], right: '' }" [dropdown]="dropdown" i="1"></app-nine-icons>
    </li>
  </ul>
  <ul class="nav navbar-nav align-items-center align-logo-center">
    <li class="nav-item d-flex flex-column align-items-center">
      <a class="navbar-brand m-0" [routerLink]="['/']">
        <span class="brand-logo">
          <img [src]="coreConfig.app.appLogoImage" alt="brand-logo" class="d-none d-md-block" />
          <img src="/assets/images/logo/osquare-pixel.png" alt="brand-logo" class="d-md-none d-block" />
        </span>
        <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2>
      </a>
      <span class="d-md-block d-none mt-50" *ngIf="station?.name" [ngbTooltip]="station?.name">{{ station?.name
        }}</span>
    </li>
  </ul>
  <ul class="nav navbar-nav align-items-center justify-content-end" style="z-index: 10">
    <li class="nav-item setup-language-nav-item" *ngIf="showSetupLanguageSwitcher">
      <div class="language-switcher" [class.open]="languageDropdownOpen">
        <button type="button" class="language-trigger" (click)="toggleLanguageDropdown($event)"
          aria-label="Language switcher" [attr.aria-expanded]="languageDropdownOpen" aria-haspopup="menu">
          <span>{{ currentLanguage === 'ar' ? 'AR' : 'EN' }}</span>
          <mat-icon [fontIcon]="languageDropdownOpen ? 'expand_less' : 'expand_more'"></mat-icon>
        </button>

        <div class="language-menu" *ngIf="languageDropdownOpen" role="menu">
          <button type="button" class="language-option" [class.active]="currentLanguage === 'en'"
            [attr.aria-pressed]="currentLanguage === 'en'" (click)="setLanguage('en')">EN</button>
          <button type="button" class="language-option" [class.active]="currentLanguage === 'ar'"
            [attr.aria-pressed]="currentLanguage === 'ar'" (click)="setLanguage('ar')">AR</button>
        </div>
      </div>
    </li>

    <li class="nav-item" *ngIf="hasActiveReleaseNotes$ | async">
      <a class="nav-link" ngbTooltip="Release Notes" (click)="openReleaseNotes()">
        <img src="assets/images/icons/home/RN.svg" alt="Release Notes" class="ficon" width="28" height="28" />
      </a>
    </li>
    <!-- <li class="nav-item">
      <a class="nav-link" ngbTooltip="Release Notes" (click)="openReleaseNotes()">
        <span data-feather="file-text" class="ficon"></span>
      </a>
    </li> -->
    <app-second-navbar (onStationChange)="handleStationChange($event)"></app-second-navbar>
    <li class="nav-item" *renderIf="{roles: ['employee'], right: 'L1305'}">
      <app-approval-notification></app-approval-notification>
    </li>
    <app-navbar-notification></app-navbar-notification>
    <li ngbDropdown class="nav-item dropdown-notification mr-25 d-md-none d-block" #dropdown1="ngbDropdown">
      <app-nine-icons *renderIf="{ roles: ['employee', 'customer'], right: '' }" [dropdown]="dropdown1" i="2"></app-nine-icons>
    </li>
    <div class="bookmark-wrapper d-flex align-items-center" *ngIf="showMenuToggle">
      <ul class="nav navbar-nav d-md-none" *ngIf="!coreConfig.layout.menu.hidden">
        <li class="nav-item">
          <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
            <span [data-feather]="'menu'" [class]="'ficon'"></span>
          </a>
        </li>
      </ul>
    </div>
    <li ngbDropdown class="nav-item dropdown-user">
      <a class="nav-link dropdown-toggle dropdown-user-link flex-column align-items-end" id="dropdown-user"
        ngbDropdownToggle id="navbarUserDropdown" aria-haspopup="true" aria-expanded="false">
        <div class="d-flex align-items-center">
          <div class="user-nav d-sm-flex d-none">
            <span class="user-name font-weight-bolder my-des alt" style="max-width: 100px"
              [ngbTooltip]="currentUser?.name">
              {{ currentUser?.firstName || currentUser?.name }}
            </span>
            <span class="user-status my-des alt" style="max-width: 100px" [ngbTooltip]="
                currentUser?.designation
                  ? currentUser?.designation
                  : currentUser?.empRole
                  ? (currentUser?.empRole | uppercase)
                  : (currentUser?.role | uppercase)
              ">
              {{
              currentUser?.designation
              ? currentUser?.designation
              : currentUser?.empRole
              ? (currentUser?.empRole | uppercase)
              : (currentUser?.role | uppercase)
              }}
            </span>
          </div>
          <span class="avatar">
            <img class="round" [src]="
                currentUser?.profilePic ??
                '../../../../assets/images/avatars/0.png'
              " alt="avatar" height="40" width="40" onerror="this.src = '../../../../assets/images/avatars/0.png'" />
            <span class="avatar-status-lg" *ngIf="currentUser?.role == 'employee'" [ngStyle]="{
                background:
                  statusColor && attendanceColor
                    ? 'linear-gradient(90deg, ' +
                      attendanceColor +
                      ' 50%, ' +
                      statusColor +
                      ' 50%)'
                    : attendanceColor,
                border: 'none',
                'background-repeat': 'no-repeat'
              }"></span>
          </span>
        </div>
      </a>
      <ul ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right">
        <ng-container *ngIf="!isCustomerPortalUser && !isStartup">
          <li *renderIf="{ roles: ['employee', 'customer'], right: ['K'] }">
            <a class="dropdown-item" routerLinkActive="active" [routerLink]="['/app/profile']">
              <span [data-feather]="'user'" [class]="'mr-50'"></span>
              Profile
            </a>
          </li>
          <li *renderIf="{ roles: ['employee'], right: 'B' }">
            <a class="dropdown-item" routerLinkActive="active" [routerLink]="['/app/chat']" (click)="setMenu('')">
              <span data-feather="message-square" [class]="'mr-50'"></span>
              Chat
            </a>
          </li>
          <li *renderIf="{ roles: ['customer'], right: '' }">
            <a class="dropdown-item" routerLinkActive="active" [routerLink]="['/app/settings']"><span
                [data-feather]="'settings'" [class]="'mr-50'"></span>
              Settings</a>
          </li>
          <li *renderIf="{ roles: ['employee'], right: '' }">
            <a class="dropdown-item" routerLinkActive="active" [routerLink]="['/app/landing-page-setting']"><span
                [data-feather]="'settings'" [class]="'mr-50'"></span>
              Setting</a>
          </li>
          <li *renderIf="{ roles: ['employee'], right: 'F1005' }">
            <a class="dropdown-item" (click)="openAttendanceModal()">
              <span data-feather="calendar" [class]="'mr-50'"></span>
              Mark Attendance</a>
          </li>
          <li *ngIf="role == 'employee'">
            <a class="dropdown-item">
              <span [data-feather]="'eye'" [class]="'mr-50'"></span>
              Change Status
            </a>
            <ul class="dropdown-menu dropdown-submenu dropdown-submenu-left" style="top: -7px !important">
              <li *ngFor="let status of statuses">
                <a class="dropdown-item" (click)="changeStatus(status.id)">
                  <span style="width: 17px; height: 17px; margin-bottom: -1px"
                    [ngStyle]="{ 'background-color': status.hex }" class="mr-50 round"></span>
                  {{ status.status }}
                </a>
              </li>
            </ul>
          </li>
          <div class="dropdown-divider"></div>
          <li *ngIf="isWorkspaceAdmin; else employeeBilling">
            <a class="dropdown-item" routerLink="/payment/history">
              <span [data-feather]="'credit-card'" [class]="'mr-50'"></span>
              Billing & Payments
            </a>
          </li>
          <ng-template #employeeBilling>
            <li *renderIf="{ roles: ['employee'], right: 'L1568' }">
              <a class="dropdown-item" routerLink="/payment/history">
                <span [data-feather]="'credit-card'" [class]="'mr-50'"></span>
                Billing & Payments
              </a>
            </li>
          </ng-template>
          <div class="dropdown-divider"></div>
        </ng-container>
        <li>
          <a class="dropdown-item" (click)="logout()"><span [data-feather]="'power'" [class]="'mr-50'"></span>
            Logout</a>
        </li>
      </ul>
    </li>
  </ul>
</div>

<ng-container *renderIf="{ roles: ['employee'], right: 'F1005' }">
  <app-attendance-add #attendanceAdd></app-attendance-add>
</ng-container>